
import { mapState, mapGetters } from 'vuex';
import { gtag } from '@/libs/utils.js';
import * as _tracker from '@/libs/tracker/actions';
import { AD_FB_EVENT_LIST } from '@xd-rocket/attributes/src/options/track';
export default {
  name: 'TrackBehavior',
  data() {
    return {
      adChannel: '', // 当前地址选用的广告渠道
      stayEls: {},
      showRecord: {},
    };
  },
  computed: {
    ...mapState(['pureInfo', 'code', 'pureNodes', 'request', 'device']),
    ...mapGetters(['$bus']),
    ads() {
      return this.pureInfo.ads;
    },
  },
  beforeMount() {
    // 裂变统计上报
    if (this.pureInfo.trackFission) {
      _tracker.fissionTrack((key, val) => {
        this.updateRouteQuery(key, val);
      });
    }
    this.$bus.$on('rocket:statistics:default-ext', (payload) => {
      window.moo.tracker.defaultExt = {
        ...window.moo.tracker.defaultExt,
        ...payload,
      };
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.$bus.$on('rocket:statistics:send', _tracker.custom);
      const types = {
        WidgetFrame: 'Page',
        WidgetRoundedRect: 'Rect',
        WidgetLinkButton: 'Button',
      };
      // 点击 / 曝光
      for (let id in this.pureNodes) {
        let node = this.pureNodes[id];
        let track = this.pureNodes[id].trackBehavior;
        if (track && track?.isReport) {
          // const objectId =
          //   track.objectId && track.objectId !== ''
          //     ? track.objectId
          //     : id + ' ' + node.title;
          const nodeType = types[node.type];
          let extra =
            track.extra === ''
              ? {}
              : { original: track.extra, custom: track.customExtra };
          // console.log(id, track.isReport, track, objectId, track.extra);
          if (track.isReportShow) {
            this.$bus.$on(
              'rocket:system:scroll-observe:' + id,
              (ELEMENT, isShow) => {
                const showType = track.showObjectType?.i18n
                  ? this.$i18n.r(
                      track.showObjectType,
                      ELEMENT.values.dataInject
                    )
                  : track.showObjectType || 'show' + nodeType;
                // 元素展示
                if (isShow) {
                  this.viewTrack(
                    showType,
                    this.getObjectId(
                      track,
                      (ELEMENT.id || id) + ' ' + node.title,
                      ELEMENT.values.dataInject
                    ),
                    extra,
                    ELEMENT.values.dataInject,
                    ELEMENT.id
                  );
                }
                if (track.isReportShowAndStay) {
                  // console.log('rocket:system:scroll-observe', id, isShow);
                  if (isShow) {
                    // 元素展示
                    this.stayEls[id] = {
                      start: new Date().getTime(),
                      objectId: this.getObjectId(
                        track,
                        (ELEMENT.id || id) + ' ' + node.title,
                        ELEMENT.values.dataInject
                      ),
                      showType,
                      extra,
                      isTop: true,
                      dataInject: ELEMENT.values.dataInject,
                      uniqueId: ELEMENT.id,
                    };
                    // console.log('开始计时', id, this.stayEls[id]);
                  } else {
                    // 元素隐藏
                    // console.log('上报停留时长', id, this.stayEls[id]);
                    if (this.stayEls[id]?.start && this.stayEls[id].start > 0) {
                      this.stayTrack(this.stayEls[id]);
                      delete this.stayEls[id];
                    }
                  }
                }
              }
            );
          }
          if (track.isReportClick) {
            this.$bus.$on('rocket:system:tap:' + id, (ELEMENT) => {
              const clickType = track.clickObjectType?.i18n
                ? this.$i18n.r(track.clickObjectType, ELEMENT.values.dataInject)
                : track.clickObjectType || 'click' + nodeType;
              this.clickTrack(
                clickType,
                this.getObjectId(
                  track,
                  (ELEMENT.id || id) + ' ' + node.title,
                  ELEMENT.values.dataInject
                ),
                extra,
                ELEMENT.values.dataInject
              );
              if (track.ad?.isReportADSAtClick) {
                this.reportAds(track.ad, ELEMENT.values.dataInject);
              }
            });
          }
        }
      }

      // this.$bus.$emit('rocket:system:pageStateChange', true);
      this.$bus.$on('rocket:system:visibilitychange', (isShow) => {
        let now = new Date().getTime();
        if (isShow) {
          // 检查恢复
          for (let id in this.stayEls) {
            let el = this.stayEls[id];
            if (el.isTop && el.start && el.start === -1) {
              // console.log('重新开始计时', id, el);
              this.stayEls[id].start = now;
            }
          }
        } else {
          // 检查上报
          for (let id in this.stayEls) {
            let el = this.stayEls[id];
            // console.log('离开 上报停留时长', id, el);
            if (el.start && el.start > 0) {
              this.stayTrack(el);
              this.stayEls[id].start = -1;
            }
          }
        }
      });
    });
    this.$nextTick(() => {
      let adChannel = '';
      if (this.ads) {
        let ads = this.ads;
        if (this.request && this.request.c) {
          adChannel = this.request.c;
          let c = ads[adChannel.toLowerCase()];
          if (!c || c === '') {
            console.error(adChannel + ' no account configured');
          }
        } else {
          for (let c in ads) {
            if (ads[c] !== '') {
              adChannel = c.toUpperCase();
            }
          }
          if (adChannel !== '') {
            // console.log('auto channel is', adChannel);
          }
        }
        let gg = this.getObjectIdByI18n(ads.gg);
        if (adChannel === 'GG' && gg && gg !== '') {
          if (gg.substr(0, 2) !== 'AW') {
            console.warn('Google ID need AW-');
          } else {
            console.log('gtag config AW');
          }
          gtag(this?.$gtag, 'js', new Date());
          gtag(this?.$gtag, 'config', gg);
        }
        this.adChannel = adChannel;
      }
      // GA 统计上报
      let deviceStr =
        (window.moo.ua.device.type || 'other') +
        '-' +
        window.moo.ua.os.name +
        '-' +
        window.moo.ua.browser.name;
      gtag(this?.$gtag, 'event', 'View', {
        event_category: '2022-08-25 ' + this.code + ' ' + adChannel,
        event_label: deviceStr,
      });
    });
    // 这个事件会被所有页面多次触发，需要限流
    this.$bus.$on('rocket:system:pageChange', (openPages) => {
      // TODO 这里可以增加页面隐藏数据
      let pages = {};
      let showPage = openPages.length
        ? openPages[openPages.length - 1]
        : this.pureInfo.primaryFrameId;
      openPages.forEach((item) => {
        pages[item] = true;
      });
      // 1、备用上报的页面已经不在最上层，此时要上报离开并清除计时间
      for (let id in this.stayEls) {
        let el = this.stayEls[id];
        if (id === showPage) {
          // 展示
          // console.log('show', el);
          if (!el.isTop) {
            this.stayEls[id].isTop = true;
            // 补一个展示上报
            this.viewTrack(
              el.showType,
              el.objectId,
              el.extra,
              el.dataInject,
              el.uniqueId
            );
          }
          let now = new Date().getTime();
          this.stayEls[id].start = now;
        } else {
          // 隐藏
          // console.log('hide', el, el?.start);
          this.stayEls[id].isTop = false;
          if (el.start && el.start > 0) {
            this.stayTrack(el);
            this.stayEls[id].start = -1;
          }
        }
      }
    });
  },
  beforeDestroy() {
    console.log('TrackBehavior beforeDestroy');
    this.$bus.$off('rocket:statistics:send');
    this.$bus.$off('rocket:statistics:default-ext');
    this.$bus.$off('rocket:system:visibilitychange');
  },
  methods: {
    updateRouteQuery(key, value) {
      let { query } = this.$route;
      if (query[key] === value) return;
      this.$router.replace({
        query: { ...query, [key]: value },
      });
    },
    getTimeDiff(start) {
      return Number(((new Date().getTime() - start) / 1000).toFixed(4));
    },
    getObjectIdByI18n(key, dataInject = {}) {
      if (!key?.i18n) {
        return key;
      }
      // 不在第一步就获取是为了避免运行过程中数据迟已经被修改
      let value = this.$i18n.r(key, dataInject);
      return value;
    },
    getObjectId(track, used, dataInject = {}) {
      let key = track.objectId;
      if (typeof key === 'string') {
        return key;
      } else if (key?.i18n) {
        return this.getObjectIdByI18n(key, dataInject);
      }
      return used;
    },
    getExtra(key, dataInject = {}) {
      if (!key) {
        // 没有配置
        return {};
      }
      let tip =
        'statistics extra needs to be an object type! However, the system will automatically complete the key';
      // 提起默认注入的属性
      let k = JSON.parse(JSON.stringify(key));
      delete k.original;
      delete k.custom;
      let initData = k;
      // 提取原始参数
      let original = {};
      if (key.original?.i18n) {
        let value = this.$i18n.r(key.original, dataInject);
        if (typeof value === 'object') {
          original = value;
        } else {
          // console.warn(tip, key, value);
        }
      } else {
        // 纯文本 json 配置
        if (typeof key.original !== 'object') {
          if (key.original?.substring(0, 1) === '{') {
            let value = JSON.parse(key.original);
            if (typeof value === 'object') {
              // console.log('original', original);
              original = value;
            } else {
              // console.warn(tip, key, value);
            }
          }
        }
      }
      // 提取自定义参数
      let custom = {};
      if (key.custom?.length) {
        key.custom.forEach((item) => {
          // console.log(item, item.value?.i18n);
          if (item.value?.i18n) {
            let value = this.$i18n.r(item.value, dataInject);
            if (value && value !== '') {
              custom[item.key] = value;
            }
          } else if (item.value !== '') {
            custom[item.key] = item.value;
          }
        });
      }
      // 合并数据
      const merged = Object.assign({}, initData, original, custom);
      return merged;
    },
    clickTrack(clickType, objectId, extra, dataInject) {
      objectId = this.getObjectIdByI18n(objectId, dataInject);
      extra = this.getExtra(extra, dataInject);
      _tracker.click(clickType, objectId, extra);
      let deviceStr =
        (window.moo.ua.device.type || 'other') +
        '-' +
        window.moo.ua.os.name +
        '-' +
        window.moo.ua.browser.name;
      gtag(this?.$gtag, 'event', 'LinkClick ' + objectId, {
        event_category: '2023-07-12 ' + this.code + ' ' + this.adChannel,
        event_label: deviceStr,
      });
    },
    viewTrack(clickType, objectId, extra, dataInject, uniqueId) {
      this.$nextTick(() => {
        objectId = this.getObjectIdByI18n(objectId, dataInject);
        extra = this.getExtra(extra, dataInject);
        if (!this.showRecord[uniqueId]) {
          _tracker.viewTrack(clickType, objectId, extra);
          this.showRecord[uniqueId] = true;
        }
      });
    },
    stayTrack(el) {
      // console.log('stayTrack', el);
      let objectId = this.getObjectIdByI18n(el.objectId, el.dataInject);
      let extra = this.getExtra(el.extra, el.dataInject);
      let stay_time = this.getTimeDiff(el.start);
      _tracker.stayTrack(el.showType, objectId, {
        ...extra,
        stay_time,
      });
    },
    reportAds(ad, dataInject) {
      // 上报广告
      const channel = this.adChannel;
      // console.log('channel', channel);
      if (channel === 'FB') {
        if (typeof window.fbq !== 'undefined') {
          let eventCode =
            this.device === 'ios'
              ? this.$i18n.r(ad.fb.ios, dataInject) || 'LinkClick iOS'
              : this.$i18n.r(ad.fb.android, dataInject) || 'LinkClick';
          let fbqEventType = 'trackCustom';
          AD_FB_EVENT_LIST.forEach((e) => {
            if (eventCode === e.value) fbqEventType = 'track';
          });
          console.log('event facebook fbq');
          window.fbq(fbqEventType, eventCode, { code: this.code });
        } else {
          console.error('fbq undefined');
        }
      } else if (channel === 'GG') {
        console.log('event google gtag');
        let gg = this.getObjectIdByI18n(this.ads.gg);
        let label =
          this.device === 'ios'
            ? this.$i18n.r(ad.gg.ios, dataInject)
            : this.$i18n.r(ad.gg.android, dataInject);
        if (label !== '') {
          gtag(this?.$gtag, 'event', 'conversion', {
            send_to: "'" + gg + '/' + label + "'",
          });
        } else {
          console.warn('gg label undefined');
        }
      } else if (channel === 'TT') {
        console.warn('event is_tiktok, but no Code');
      } else if (channel === 'TW') {
        // console.warn('twitter', ad.tw);
        window.twq(
          'event',
          this.device === 'ios'
            ? this.$i18n.r(ad.tw.ios, dataInject)
            : this.$i18n.r(ad.tw.android, dataInject),
          {}
        );
      } else if (channel === 'RE') {
        if (typeof rdt !== 'undefined') {
          console.log('event reddit rdt');
          window.rdt(
            'track',
            this.device === 'ios'
              ? this.$i18n.r(ad.re.ios, dataInject) // 'AddToWishlist'
              : this.$i18n.r(ad.re.android, dataInject) // 'AddToCart'
          );
        } else {
          console.error('rdt undefined');
        }
      } else {
        console.warn('no channel! please use "?c=FB" or "?c=GG / TT / RE"');
      }
    },
  },
};
